<template>
  <el-row v-loading="loading">
    <!-- 左侧区域开始 -->
    <el-col :md="24" :lg="17">

      <!-- 上区域 -->
      <div class="content-item">
        <div class="content-box">
          <div class="title">线路及包裹</div>
          <!-- 线路选择 -->
          <el-radio-group v-model="data.id" size="medium" @change="getQuery">
            <el-radio-button v-for="(item, index) in type" :key="index" :label="item.id">
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
          <!-- 包裹组件 -->
          <!--<HomeBultos v-model="data.bultos" :id="data.id" @change="getQuery" @order="setQuery" v-if="components.HomeBultos"></HomeBultos>-->
          <!-- 保险与备注 -->
          <div class="home-form">
            <el-form label-position="top">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="包裹数" style="font-weight: bold">
                    <el-input
                      placeholder="包裹数"
                      prefix-icon="el-icon-box"
                      v-model.number="bultos"
                      @change="setBultos"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="总重量(KG)">
                    <el-input
                      placeholder="总重量"
                      prefix-icon="el-icon-coin"
                      v-model.number="data.now_weight"
                      @change="getQuery"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="保险">
                    <el-input
                      prefix-icon="el-icon-truck"
                      v-model.number="data.seguro"
                      @change="getQuery"
                      clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="待收款">
                    <el-input
                      prefix-icon="el-icon-finished"
                      v-model.number="data.reembolso"
                      clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-input
                placeholder="备注"
                prefix-icon="el-icon-edit"
                v-model="data.observac"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="12">
              <el-radio-group v-model="data.crea" size="medium" @change="onCrea">
                <el-radio-button label="N">
                  固定网点取件下单
                </el-radio-button>
                <el-radio-button label="S">
                  临时上门取件下单
                </el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 下区域开始 -->
      <el-row>
        <!-- 左侧 -->
        <el-col :md="24" :lg="12">
          <div class="content-item">
            <div class="content-box">
              <div class="title">发件人</div>
              <!-- 表单组件 -->
              <HomeFa ref="fa" v-if="components.HomeFa"></HomeFa>
            </div>
          </div>
        </el-col>

        <!-- 右侧 -->
        <el-col :md="24" :lg="12">
          <div class="content-item">
            <div class="content-box">
              <div class="title">收件人</div>
              <!-- 表单组件 -->
              <HomeShou ref="shou" v-if="components.HomeShou"></HomeShou>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 下区域结束 -->
    </el-col>
    <!-- 左侧区域结束 -->

    <!-- 右侧区域开始 -->
    <el-col :md="24" :lg="7">
      <div class="content-item">
        <div class="content-box" v-loading="orderLoading">
          <div class="title">准备下单</div>
          <div class="order">
            <div class="order-item">
              需要积分 <b>€{{ order.money }}</b>
            </div>
            <div class="order-item">
              保险手续 <b>€{{ order.baoxian }}</b>
            </div>
            <div class="order-item" v-if="order.price">
              燃油费率 <b>已含 {{ order.price.rate }}%</b>
            </div>
            <div class="order-item">
              运单编号 <b>{{ order.code }}</b>
            </div>
            <div class="order-item">
              物流编号 <b>{{ order.hao }}</b>
            </div>
            <div class="order-item">
              PDF下载 <b><a :href="order.pdf" target="_blank" v-show="order.pdf">点击下载</a></b>
            </div>
            <div class="order-btn">
              <el-button type="danger" @click="startOrder">开始下单</el-button>
              <el-button type="primary" @click="refresh" plain>清空数据</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <!-- 右侧区域结束 -->

  </el-row>
</template>
<script>
import { type, query, order } from '../api/api';
// import HomeBultos from '../components/HomeBultos'
import HomeFa from '../components/HomeFa'
import HomeShou from '../components/HomeShou'

export default {
  name: 'Home',
  components: {
    // HomeBultos,
    HomeFa,
    HomeShou
  },
  metaInfo(){
    return {
      title: '境内24小时',
    }
  },
  data() {
    return {
      loading: true,
      type: [],
      config: {},
      bultos: 1,

      data: {
        id: 0,
        bultos: [],
        now_weight: 0,
        // 保险
        seguro: '',
        // 备注
        observac: '',
        // 代收
        reembolso: '',
        // 类型
        crea: 'N'
      },

      order: {
        money: 0,
        baoxian: 0
      },
      orderLoading: false,

      // 组件刷新
      components: {
        HomeBultos: true,
        HomeFa: true,
        HomeShou: true
      }
    }
  },
  created() {
    // 请求线路
    this.getType()
    this.setBultos()
  },
  methods: {
    getType() {
      type().then(data => {
        this.type = data.type
        this.config = data.config
        this.data.id = this.type[0].id
        this.loading = false
        this.onCrea(this.data.crea)
      })
    },
    getQuery() {
      this.orderLoading = true
      query(this.data).then(data => {
        this.orderLoading = false
        if(data.err) {
          return this.$message({
            message: data.msg,
            type: 'error'
          });
        }
        this.setQuery(data)
      })
    },
    setQuery(order) {
      this.order = order
    },
    // 选择类型
    onCrea(crea) {
      // 配置收件人
      //const shou = this.$refs['shou']
      if (crea == 'N') {
        // 清空配置
        //shou.empty()
      } else {
        // 填写速欧
        //shou.set(Object.assign({}, this.config))
      }
    },
    setBultos() {
        const bultos = []
        for(let i = 0; i < this.bultos; i++) {
            bultos.push({
                orden: i,
                largo: 0,
                ancho: 0,
                alto: 0,
                kilos: 0,
            })
        }
        this.data.bultos = bultos
    },
    // 开始下单
    async startOrder() {
      // 合并收发人
      Object.assign(this.data, await this.$refs['fa'].get())
      Object.assign(this.data, await this.$refs['shou'].get())

      // 请求下单接口
      this.orderLoading = true
      order(this.data).then(data => {
        this.orderLoading = false
        if(data.err) {
          return this.$message({
            message: data.msg,
            type: 'error'
          });
        }
        this.order = data
      })
    },
    // 重装数据
    refresh() {
      // 利用 v-if 刷新组件
      this.components = {
        HomeBultos: false,
        HomeFa: false,
        HomeShou: false
      }
      // 刷新数据
      this.order = {
        money: 0,
        baoxian: 0
      }
      // 保险备注
      this.data.seguro = ''
      this.data.now_weight = 0
      this.data.observac = ''
      this.data.reembolso = ''

      // 显示组件
      this.$nextTick(() => {
        this.components = {
          HomeBultos: true,
          HomeFa: true,
          HomeShou: true
        }
        // 延迟显示
        setTimeout(() => {
            this.onCrea(this.data.crea)
        }, 300);

        // 刷新完成
        this.$notify({
          title: '清空成功',
          message: '您可以重新开始下单',
          type: 'success'
        });
      })
    }
  },
}
</script>
<style lang="scss">
.home-form {
  margin-top: 20px;
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}
</style>